<template>
    <div style="height: 70px; min-height: 70px; width: calc(100% - 30px)">
        <div class="sot-button-bg row items-center no-wrap cursor-pointer" style="height: 64px; width: 100%; z-index: 100; margin-left: -8px">
            <div class="col-auto items-center">
                <div style="width: 42px; height: 42px; margin-left: 4px" class="flex flex-center">
                    <q-img :src="params.icon_url" width="32px" height="32px" fit="contain" no-spinner />
                </div>
            </div>
            <div style=" margin: 0 20px 0 20px" class="sot-font">
                <div class="ellipsis-2-lines text-left">{{ label }}</div>
                <div class="ellipsis text-left" style="font-size: 14px;">{{ author }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SotButton',
    props: {
        params: {
            type: Object,
            default: undefined,
        },
        label: {
            type: String,
            default: undefined,
        },
    },
    data () {
        return {
            author: undefined,
        };
    },
    mounted () {
        this.loadAuthor();
    },
    methods: {
        loadAuthor () {
            const { to } = this.params;
            const { author } = this.params;
            if (author) {
                this.author = author;
            }
            if (to && to.length > 8) {
                this.$factory.getPageAuthor(to).then((p) => {
                    if (p) {
                        this.author = p.author;
                    }
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .sot-button-bg {
        background-image: url('~assets/ui/sot-button.svg') !important;
        background-repeat: no-repeat;
        background-size: 100%;
        z-index: 999;
        // transition: transform 3s;
    }
    .sot-button-bg:hover {
        background-image: url('~assets/ui/sot-button-focused.svg') !important;
        background-repeat: no-repeat;
        background-size: 100%;
        z-index: 999;
    }
</style>
